// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.loader-container[data-v-7126417e] {\r\nposition: fixed;\r\ntop: 0;\r\nleft: 0;\r\nwidth: 100%;\r\nheight: 100%;\r\nbackground-color: white;\r\nopacity: 0.5;\r\nz-index: 1000;\n}\n.loader-content[data-v-7126417e] {\r\nposition: absolute;\r\ntop: 40%;\r\nleft: 50%;\r\ntransform: translate(-50%, -50%);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
